import { render, staticRenderFns } from "./HuyHieuForm.vue?vue&type=template&id=1558712a&"
import script from "./HuyHieuForm.vue?vue&type=script&lang=js&"
export * from "./HuyHieuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports